import React from "react";
import Avatar from "../images/avatar.png";

const AboutSection: React.FC = () => {
    return (
        <section id="about" className="py-16 px-6 bg-white">
            <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-10">
                <img
                    src={Avatar}
                    alt="Aishwarya Rao"
                    className="w-40 h-40 rounded-full shadow-lg object-cover"
                />
                <div>
                    <h2 className="text-3xl font-display font-bold text-gray-800 mb-4">
                        About
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                        Hi, I'm Aishwarya&nbsp;— a software engineer based in Singapore with
                        5+ years of experience crafting distributed systems, developer
                        tooling, and internal SDLC platforms. I love optimizing
                        performance, architecting scalable back-ends, and building tools
                        that boost engineering productivity.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutSection; 